import { createSlice } from '@reduxjs/toolkit';

import { actions } from './generation-state.actions';
import { IGenerationStateInitial } from './generation-state.types';

const initialState: IGenerationStateInitial = {
  stateId: '',
  sendingStateId: '',
  prefix: '',
  isLoading: false,
  progress: {
    total: 0,
    generated: 0,
    failed: 0,
    status: 'none',
    errors: [],
  },
  excelFiles: {
    customerFileName: '',
    monthFileName: '',
    staffFileName: '',
  },
};

const generationStateSlice = createSlice({
  name: 'generationStateSlice',
  initialState,
  reducers: actions,
});

export const generationStateReducer = generationStateSlice.reducer;
export const generationStateActions = generationStateSlice.actions;
export const {
  setPrefix,
  updateProgress,
  resetGenerationProgress,
  resetState,
  setGenerationStateDetails,
  setGenerationErrors,
  resetGenerationErrors,
  setFileName,
  setSendingState,
  resetSendingState,
  setGenerationIsLoading,
} = generationStateSlice.actions;
